import assetsBase from '@exodus/assets-base'
import { cleanInput } from '@exodus/basic-utils'
import { joinUrl, omitUndefinedValues } from '../utils.js'
import { ORDER_TYPES, PROVIDERS } from '../constants.js'
import rampAdapter from './adapter.js'
import { DEFAULT_CRYPTO_PRECISION, ENABLED_ASSETS, RAMP_URL } from './constants.js'

const assets = assetsBase.default || assetsBase

const getUrlWithOrderId = (orderId, url, ...paths) => {
  if (!url) {
    return
  }

  return joinUrl(url, ...paths, omitUndefinedValues({ orderId }))
}

export const getWidgetUrl = ({
  appName,
  apiKey,
  assets: assets_ = ENABLED_ASSETS,
  countryCode,
  fromAmount,
  fromAsset,
  fromAssetPrecision = DEFAULT_CRYPTO_PRECISION,
  finalUrl,
  logoUrl,
  orderId,
  serverUrl,
  toAmount,
  toAsset = [],
  toAssetPrecision = DEFAULT_CRYPTO_PRECISION,
  type = ORDER_TYPES.buy,
  url = RAMP_URL,
  walletAddress,
  origin,
} = {}) => {
  if (type !== ORDER_TYPES.buy) {
    throw new Error('Only `buy` orders are accepted')
  }

  if (!apiKey) {
    throw new Error('`apiKey` is required')
  }

  if (fromAmount && toAmount) {
    throw new Error('`fromAmount` and `toAmount` are mutually exclusive')
  }

  if (fromAmount && !fromAsset) {
    throw new Error('`fromAsset` is required when `fromAmount` is provided')
  }

  if (toAmount && toAsset.length === 0) {
    throw new Error('`toAsset` is required when `toAmount` is provided')
  }

  const selectedAsset = toAsset.length > 0 ? assets[toAsset[0]] : undefined
  const toAssets = toAsset.map((asset) => rampAdapter.fromExodusToProviderAsset(asset, assets_))
  const fiatValue = fromAmount ? cleanInput(String(fromAmount), fromAssetPrecision) : fromAmount
  const swapAmount = toAmount ? cleanInput(String(toAmount), toAssetPrecision) : toAmount
  const searchParameters = new URLSearchParams(
    omitUndefinedValues({
      hostApiKey: apiKey,
      fiatCurrency: fromAsset,
      fiatValue,
      finalUrl: getUrlWithOrderId(
        orderId,
        finalUrl,
        omitUndefinedValues({ provider: PROVIDERS.ramp, origin })
      ),
      hostAppName: appName,
      hostLogoUrl: logoUrl,
      selectedCountryCode: countryCode,
      swapAmount:
        selectedAsset && swapAmount !== undefined
          ? selectedAsset.currency.defaultUnit(swapAmount).toBaseNumber()
          : undefined,
      swapAsset: toAssets.join(',') || undefined,
      userAddress: walletAddress,
      webhookStatusUrl: getUrlWithOrderId(orderId, serverUrl, 'api/order/ramp'),
    })
  )

  return joinUrl(url, `?${searchParameters}`)
}
